import { MYSTABLE_EMAIL_UNSUBSCRIBE , MYSTABLE_EMAIL_UNSUBSCRIBE_SUCCESS, MYSTABLE_EMAIL_UNSUBSCRIBE_FAIL } from '../actions/myStable'


export default (config, apiClient) => {
    const postAPIUnsubscribe = sendUnsubscribeRequest(apiClient, config.api.common.userService.unsubscribeEmail)

    return {
        unsubscribeEmail
    }

    function unsubscribeEmail(store, next, action) {
        if (action.type === MYSTABLE_EMAIL_UNSUBSCRIBE) {
            const {email = null, token = null } = action;
            if (!email || !token) {
                store.dispatch({type: MYSTABLE_EMAIL_UNSUBSCRIBE_FAIL});
                return next(action);
            }
            postAPIUnsubscribe(email, token)
                .then(() => {
                    store.dispatch({type: MYSTABLE_EMAIL_UNSUBSCRIBE_SUCCESS})
                })
                .catch(() => {
                    store.dispatch({type: MYSTABLE_EMAIL_UNSUBSCRIBE_FAIL})
                })
        }
        return next(action);
    }
}

function sendUnsubscribeRequest(apiClient, url) {
    return (email, token) => {
        return apiClient.post(url, { data: { email, token}});
    }
}


// WEBPACK FOOTER //
// ./modules/HorseRacing/middleware/myStableEmailUnsubscribe.js